// BannerSlider.js
import React, { useState, useEffect } from "react";

// Sample banner data with title, content, and anchor tag
const bannerData = [
  {
    title: "Innovate | Design | Develop | Deliver",
    content:
      "Transforming ideas into seamless digital solutions with expert UI/UX, app development, and web development services.",
    link: "https://cogniitec.com/",
  },
  {
    title: " Transform Your Business ",
    content: "Driving Digital Adoption through BNR Cogniitec.",
    link: "https://cogniitec.com/",
  },
  {
    title: "Beyond Boundaries",
    content: "Breaking Limits, Shaping the Future with Innovation",
    link: "https://cogniitec.com/",
  },
];

const BannerSlider = () => {
  // State to keep track of the current index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Change banner every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === bannerData.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="banner-slider">
      <div className="banner" key={currentIndex}>
        <h2>{bannerData[currentIndex].title}</h2>
        <p>{bannerData[currentIndex].content}</p>
        <a
          className="btn-grad"
          href={bannerData[currentIndex].link}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn More
        </a>
      </div>
    </div>
  );
};

export default BannerSlider;
